import { Country, Language } from 'shared/types';

const isLanguageAvailable = (code: string, languages?: Language[]) =>
  languages?.some((language) => language.code === code);

const isCountryAvailable = (code: string, countries?: Country[]) =>
  countries?.some((country) => country.code === code);

export const isLocaleAvailable = (
  locale: string,
  languages?: Language[],
  countries?: Country[]
) => {
  const localeSplit = locale.split('-');
  const localeLang = localeSplit.length > 2 ? 
                        `${localeSplit[0]}-${localeSplit[1]}` 
                        : localeSplit[0];
  const localeCountry = localeSplit[localeSplit.length -1];

  if (localeCountry) {
    return (
      isLanguageAvailable(localeLang, languages) &&
      isCountryAvailable(localeCountry, countries)
    );
  };

  return isLanguageAvailable(localeLang, languages);
};
